const aiFacesRouter = [
  // 推荐列表页
  {
    path: '/ai/faces',
    name: 'ai-faces',
    component: () => import(/* webpackChunkName: "ai_faces" */ '@/views/AiFaces/AiIndex'),
    meta: {
      isLogin: false,
      diffShare: true
    }
  },
  {
    path: '/ai/result',
    name: 'ai-result',
    component: () => import(/* webpackChunkName: "ai_faces" */ '@/views/AiFaces/Result'),
    meta: {
      isLogin: false,
      diffShare: true
    }
  },
  {
    path: '/ai/share',
    name: 'ai-share',
    component: () => import(/* webpackChunkName: "ai_faces" */ '@/views/AiFaces/ShareCard'),
    meta: {
      isLogin: false,
      diffShare: true
    }
  }
]

export default aiFacesRouter
